import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mainFormTransfer" }
const _hoisted_2 = { class: "rowLine" }
const _hoisted_3 = { class: "radiobutton-wrapper colElement" }
const _hoisted_4 = { class: "dflex" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "isGroup" }, "Признак группы", -1)
const _hoisted_6 = { class: "colElement" }
const _hoisted_7 = { class: "rowLine" }
const _hoisted_8 = { class: "colElement" }
const _hoisted_9 = { class: "colElement" }
const _hoisted_10 = { class: "rowLine" }
const _hoisted_11 = { class: "colElement" }
const _hoisted_12 = { class: "colElement" }
const _hoisted_13 = { class: "colElement" }
const _hoisted_14 = { class: "rowLine" }
const _hoisted_15 = { class: "colElement" }
const _hoisted_16 = { class: "colElement" }
const _hoisted_17 = { class: "colElement" }
const _hoisted_18 = { class: "colElement" }
const _hoisted_19 = { class: "rowLine" }
const _hoisted_20 = { class: "colElement w-100" }
const _hoisted_21 = { class: "rowLine" }
const _hoisted_22 = { class: "colElement w-100" }
const _hoisted_23 = { class: "rowLine" }
const _hoisted_24 = { class: "colElement w-100" }
const _hoisted_25 = { class: "rowLine" }
const _hoisted_26 = { class: "colElement w-100" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_input = _resolveComponent("base-input")
  const _component_selector_person = _resolveComponent("selector-person")
  const _component_common_selector = _resolveComponent("common-selector")
  const _component_datepicker = _resolveComponent("datepicker")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            id: "isGroup",
            type: "checkbox",
            name: "isGroup",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.freeoffer.isGroup = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.freeoffer.isGroup]
          ]),
          _hoisted_5
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_base_input, {
          type: "text",
          name: "countPassenger",
          value: _ctx.freeoffer.NumberOfPersons,
          placeholder: "Кол-во пассажиров",
          disabled: !_ctx.freeoffer.isGroup
        }, null, 8, ["value", "disabled"])
      ])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.freeoffer.PersonList, (person, index) => {
      return (_openBlock(), _createBlock(_component_selector_person, {
        key: person.uuid,
        contractId: _ctx.contractId,
        onSetPerson: $event => (_ctx.setPerson(index, $event)),
        onDeletePersone: $event => (_ctx.deletePersone(index))
      }, null, 8, ["contractId", "onSetPerson", "onDeletePersone"]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode("button", {
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.addPerson(...args))),
      class: "order-create-btn",
      disabled: _ctx.freeoffer.isGroup && _ctx.freeoffer.PersonList.length > 0
    }, " + Добавить человека ", 8, ["disabled"]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        (_ctx.OrderTypeId)
          ? (_openBlock(), _createBlock(_component_common_selector, {
              key: 0,
              type: _ctx.supplierType,
              placeholder: "Поставщик услуги",
              onItemSet: _cache[3] || (_cache[3] = $event => (_ctx.setData($event, 'SupplierId'))),
              subListId: _ctx.OrderTypeId
            }, null, 8, ["type", "subListId"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_9, [
        (_ctx.freeoffer.SupplierId)
          ? (_openBlock(), _createBlock(_component_common_selector, {
              key: 0,
              type: _ctx.supplierContactType,
              placeholder: "Контракт с поставщиком",
              onItemSet: _cache[4] || (_cache[4] = $event => (_ctx.setData($event, 'SupplierContractId'))),
              subListId: _ctx.freeoffer.SupplierId
            }, null, 8, ["type", "subListId"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_common_selector, {
          type: _ctx.paymentTypeType,
          placeholder: "Тип оплаты",
          onItemSet: _cache[5] || (_cache[5] = $event => (_ctx.setData($event, 'PaymentType', 'entityName')))
        }, null, 8, ["type"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_common_selector, {
          type: _ctx.curencyType,
          placeholder: "Валюта",
          onItemSet: _cache[6] || (_cache[6] = $event => (_ctx.setData($event, 'CurrencyId')))
        }, null, 8, ["type"])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_base_input, {
          type: "text",
          name: "Price",
          value: _ctx.freeoffer.Price,
          onInput: _cache[7] || (_cache[7] = $event => (_ctx.simpleSetData($event, 'Price'))),
          placeholder: "Ориентировочная стоимость"
        }, null, 8, ["value"])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_base_input, {
          type: "text",
          name: "Name",
          value: _ctx.freeoffer.Name,
          onInput: _cache[8] || (_cache[8] = $event => (_ctx.simpleSetData($event, 'Name'))),
          placeholder: "Название услуги"
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_datepicker, {
          placeholder: "Дата начала мероприятия",
          "monday-first": true,
          modelValue: _ctx.freeoffer.DateFrom,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.freeoffer.DateFrom = $event)),
          "wrapper-class": "vuejs3-datepicker__wrapper vuejs3-datepicker__wrapper--high"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_datepicker, {
          placeholder: "Дата окончания мероприятия.",
          "monday-first": true,
          modelValue: _ctx.freeoffer.DateTo,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.freeoffer.DateTo = $event)),
          "wrapper-class": "vuejs3-datepicker__wrapper vuejs3-datepicker__wrapper--high vuejs3-datepicker__wrapper--right"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_Calendar, {
          modelValue: _ctx.freeoffer.TimeFrom,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.freeoffer.TimeFrom = $event)),
          showTime: true,
          timeOnly: true,
          placeholder: "Время начала мероприятия"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_Calendar, {
          modelValue: _ctx.freeoffer.TimeTo,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.freeoffer.TimeTo = $event)),
          showTime: true,
          timeOnly: true,
          placeholder: "Время окончания мероприятия"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, [
        _createVNode(_component_base_input, {
          name: "Comment",
          value: _ctx.freeoffer.Comment,
          onInput: _cache[13] || (_cache[13] = $event => (_ctx.simpleSetData($event, 'Comment'))),
          placeholder: "Комментарий",
          textarea: true
        }, null, 8, ["value"])
      ])
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        _createVNode(_component_base_input, {
          name: "PatternText",
          value: _ctx.freeoffer.PatternText,
          onInput: _cache[14] || (_cache[14] = $event => (_ctx.simpleSetData($event, 'PatternText'))),
          placeholder: "Шаблонный текст",
          textarea: true
        }, null, 8, ["value"])
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _createVNode(_component_base_input, {
          name: "CancelConditionChange",
          value: _ctx.freeoffer.CancelConditionChange,
          onInput: _cache[15] || (_cache[15] = $event => (_ctx.simpleSetData($event, 'CancelConditionChange'))),
          placeholder: "Условия аннуляции / изменения, штраф",
          textarea: true
        }, null, 8, ["value"])
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode("button", {
          onClick: _cache[16] || (_cache[16] = _withModifiers((...args) => (_ctx.createTransfer(...args)), ["prevent"])),
          class: "order-create-btn",
          disabled: !_ctx.isValid
        }, " Создать ", 8, ["disabled"])
      ])
    ])
  ]))
}